









































































































































































































































































































































































































































































import _ from "lodash";
import rest from "@/rest";
import { Component, Vue } from "vue-property-decorator";
import { vuex } from "@/store";
import { Action, namespace } from "vuex-class";
import router from "@/router";
import moment from "moment";
// components
import ExBundleStatus from "../components/ExerciseComponents/ExBundleStatus.vue";
import SimpleMessageBox from "../components/Shared/SimpleMessageBox.vue";
// import VueQrcode from "@chenfengyuan/vue-qrcode"; // https://github.com/fengyuanchen/vue-qrcode
// interfaces
import { PortalUserVM, SelectListItem } from "@/interfaces/PortalUserVM";
import { ParamGetExercises } from "@/interfaces/ParamGetExercises";
import { ExSubject } from "@/interfaces/ExSubject";
// import { ExBundleVM } from '@/interfaces/ExBundleVM';
import { ParamBool } from '@/interfaces/ParamBool';
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { ResultOverviewVM } from '@/interfaces/ResultOverviewVM';
import { ExBundleAssignmentVM } from "@/interfaces/ExBundleAssignmentVM";
// import { GroupVm } from "@/interfaces/GroupVm";
import { ExCategory2 } from "@/interfaces/ExCategory2";
import { ExCategory1 } from "@/interfaces/ExCategory1";
import { ExCategory3 } from "@/interfaces/ExCategory3";
import { GroupExtVm } from "@/interfaces/GroupExtVm";
import { CategorySelectListsVm } from "@/interfaces/CategorySelectListsVm";
import { ExBundleVM } from "@/interfaces/ExBundleAssignmentGroupVM";


const globals = namespace("globals");
const auth = namespace("auth");

@Component({
  components: {
    ExBundleStatus,
    SimpleMessageBox
  }
})
export default class MyExercisesView extends Vue {
  // @globals.Getter selectedGroup!: GroupVm;
  // @globals.Action SelectGroup: any;
  // @globals.Getter selectedUser!: PortalUserVM;
  // @globals.Getter selectedSubject!: ExSubject;
  // @globals.Getter selectedCategory2!: ExCategory2;
  @auth.Getter isAdmin: any;
  @auth.Getter isGroupAdmin: any;
  @auth.Getter isLearner: any;

  // users: PortalUserVM[] | null = null;
  // selectedUserId: string | null = null;
  // groups: GroupExtVm[] | null = null;
  // selectedGroupId: number = 0;
  bundleAssignments: ExBundleAssignmentVM[] | null = [];
  // filtered list used in the UI (searchable)
  filteredBundleAssignments: ExBundleAssignmentVM[] = [];
  searchQuery: string = '';
  private debouncedFilter: ((...args: any[]) => void) | null = null;
  // dialog state for certificate summary
  showCertDialog: boolean = false;
  certDialogText: string = '';
  certDialogTitle: string = '';
  subjectParam: ParamBool = { value: true };
  paramDir: ParamDictionary = { dictionary: {}};
  category1Items: ExCategory1[] = [];
  selectedCat1Item: ExCategory1 | null = null;
  category2Items: ExCategory2[] = [];
  selectedCat2Item: ExCategory2 | null = null;
  category3Items: ExCategory3[] = [];
  selectedCat3Item: ExCategory3 | null = null;

  resultsOverview: ResultOverviewVM | null = null;
  selectAll: boolean = true;
  announcementTimeoutId: number | null = null;
  // handler reference so we can remove the listener later
  private focusinHandler: ((event: FocusEvent) => void) | null = null;

  breadcrumbItems = [
    { text: 'Start', disabled: false, href: '/home' },
    { text: 'MeineSchulungen', disabled: true, href: '/myExercises' },
 ];

  async mounted() {
    vuex.globals.setUser(vuex.auth.portalUser);
    await this.getResults();
    await this.loadCategories("cat1");
    await this.getExBundles();

    // Add focus debugging
    // this.addFocusDebugging();

    // Focus first exercise bundle after data is loaded
    this.$nextTick(() => {
      this.focusFirstExerciseBundle();
    });

    // Add document-level focusin listener to reliably detect Tab navigation
    this.focusinHandler = (e: FocusEvent) => this.onFocusIn(e);
    document.addEventListener('focusin', this.focusinHandler);

    // setup debounced filter for search input
    this.debouncedFilter = _.debounce(() => this.applyFilter(), 300);
    this.$watch('searchQuery', () => {
      if (this.debouncedFilter) this.debouncedFilter();
    });
  }

  handleKeyNavigation(event: KeyboardEvent, currentIndex: number) {
    if (!this.bundleAssignments || this.bundleAssignments.length === 0) return;

    let targetIndex = -1;

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        event.preventDefault();
        targetIndex = currentIndex + 1;
        if (targetIndex >= this.bundleAssignments.length) {
          targetIndex = 0; // Wrap to first item
        }
        break;

      case 'ArrowUp':
      case 'ArrowLeft':
        event.preventDefault();
        targetIndex = currentIndex - 1;
        if (targetIndex < 0) {
          targetIndex = this.bundleAssignments.length - 1; // Wrap to last item
        }
        break;

      case 'Home':
        event.preventDefault();
        targetIndex = 0;
        break;

      case 'End':
        event.preventDefault();
        targetIndex = this.bundleAssignments.length - 1;
        break;

      default:
        return; // Don't handle other keys
    }

    // Focus the target item
    this.focusListItem(targetIndex);
  }

  focusListItem(index: number) {
    this.$nextTick(() => {
      const listItems = document.querySelectorAll('.exercise-bundle-item');
      if (listItems[index]) {
        (listItems[index] as HTMLElement).focus();

        // Announce the current position for screen readers
        const currentBundle = this.bundleAssignments![index];
        const bundleName = currentBundle?.exBundle?.name || 'Unbekannte Schulung';
        this.announceToScreenReader(`${bundleName}, Position ${index + 1} von ${this.bundleAssignments!.length}`);
      }
    });
  }

  // addFocusDebugging() {
  //   // Add global focus event listener for debugging
  //   document.addEventListener('focusin', (event) => {
  //     console.log('Focus moved to:', event.target);
  //     console.log('Element class:', (event.target as HTMLElement)?.className);
  //     console.log('Element tag:', (event.target as HTMLElement)?.tagName);
  //     console.log('Element aria-label:', (event.target as HTMLElement)?.getAttribute('aria-label'));
  //     console.log('---');
  //   });

  //   // Add keyboard event listener to show current focus
  //   document.addEventListener('keydown', (event) => {
  //     if (event.key === 'F12') { // Press F12 to log current focus
  //       console.log('Current focus:', document.activeElement);
  //       console.log('Active element details:', {
  //         tag: (document.activeElement as HTMLElement)?.tagName,
  //         class: (document.activeElement as HTMLElement)?.className,
  //         id: (document.activeElement as HTMLElement)?.id,
  //         ariaLabel: (document.activeElement as HTMLElement)?.getAttribute('aria-label')
  //       });
  //     }
  //   });
  // }

  beforeDestroy() {
    // Clean up event listeners
    // document.removeEventListener('focusin', this.addFocusDebugging);
    // document.removeEventListener('keydown', this.addFocusDebugging);
    if (this.focusinHandler) {
      document.removeEventListener('focusin', this.focusinHandler);
      this.focusinHandler = null;
    }
  }

  async focusFirstExerciseBundle() {
    // Wait a bit more to ensure DOM is fully rendered
    await this.$globalHelper.delay(300);
    const list = (this.filteredBundleAssignments && this.filteredBundleAssignments.length > 0) ? this.filteredBundleAssignments : this.bundleAssignments;
    if (list && list.length > 0) {
      // Use CSS selector to find the first exercise bundle
      const firstBundleElement = document.querySelector('.first-exercise-item') as HTMLElement;

      if (firstBundleElement && typeof firstBundleElement.focus === 'function') {
        firstBundleElement.focus();
        // Announce to screen reader
        const firstBundle = list[0];
        const bundleName = firstBundle?.exBundle?.name || 'Erste Schulung';
        this.announceToScreenReader(`${list.length} Schulungen geladen. Erste Schulung "${bundleName}" ist fokussiert.`);
      } else {
        // Fallback: try to find any exercise bundle item
        const anyBundleElement = document.querySelector('.exercise-bundle-item') as HTMLElement;
        if (anyBundleElement && typeof anyBundleElement.focus === 'function') {
          anyBundleElement.focus();
          this.announceToScreenReader(`${list.length} Schulungen geladen. Erste Schulung ist fokussiert.`);
        } else {
          console.warn('Could not focus first exercise bundle element');
          this.announceToScreenReader(`${list.length} Schulungen geladen.`);
        }
      }
    } else {
      // If no bundles available, announce this
      this.announceToScreenReader('Keine Schulungen verfügbar.');
    }
  }

  onFocusIn(event: FocusEvent) {
    const target = event.target as HTMLElement | null;
    if (!target) return;

    // Find the closest exercise item element
    const itemEl = target.closest('.exercise-bundle-item') as HTMLElement | null;
    if (itemEl) {
      // Determine index among exercise items in the currently displayed list
      const listItems = Array.from(document.querySelectorAll('.exercise-bundle-item')) as HTMLElement[];
      const index = listItems.indexOf(itemEl);
      const currentList = (this.filteredBundleAssignments && this.filteredBundleAssignments.length > 0) ? this.filteredBundleAssignments : this.bundleAssignments || [];
      if (index >= 0 && currentList && currentList[index]) {
        const bundle = currentList[index];
        const name = bundle.exBundle ? this.getBundleName(bundle.exBundle) : 'Unbekannte Schulung';
        this.announceToScreenReader(`${name}, Position ${index + 1} von ${currentList.length}`);
      }
    }
  }

  announceToScreenReader(message: string) {
    // Create or update live region for announcements.
    // Use inline styles so the element is hidden but visible in DevTools
    // (scoped CSS would not apply when appended to document.body).
    if (!message) return;
    let announcement = document.getElementById('page-announcements') as HTMLDivElement | null;
    if (!announcement) {
      announcement = document.createElement('div');
      announcement.id = 'page-announcements';
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      // Inline sr-only styles to avoid relying on scoped CSS
      announcement.style.position = 'absolute';
      announcement.style.width = '1px';
      announcement.style.height = '1px';
      announcement.style.padding = '0';
      announcement.style.margin = '-1px';
      announcement.style.overflow = 'hidden';
      // Use clip and clipPath for broader browser support
      announcement.style.clip = 'rect(0 0 0 0)';
      announcement.style.whiteSpace = 'nowrap';
      announcement.style.border = '0';
      document.body.appendChild(announcement);
    }

    // Set text and keep it visible slightly longer for debugging/AT to pick it up
    announcement.textContent = message;
    console.debug('SR announce:', message);

    // Clear any previous timeout so a new announcement isn't cleared by an old timer
    if (this.announcementTimeoutId) {
      clearTimeout(this.announcementTimeoutId);
      this.announcementTimeoutId = null;
    }

    // Clear after announcement (3s gives screen readers time to pick it up)
    this.announcementTimeoutId = window.setTimeout(() => {
      const el = document.getElementById('page-announcements');
      if (el) el.textContent = '';
      this.announcementTimeoutId = null;
    }, 3000) as unknown as number;
  }

  async cat1Changed(cat1: ExCategory1) {
    // console.log("grade changed, get exercises")
    this.selectedCat1Item = cat1;
    await this.loadCategories("cat1");
    this.getExBundles();
  }

  async cat2Changed(cat2: ExCategory2) {
    // console.log("grade changed, get exercises")
    this.selectedCat2Item = cat2;
    await this.loadCategories("cat2");
    this.getExBundles();
  }

  async cat3Changed(cat3: ExCategory3) {
    // console.log("grade changed, get exercises")
    this.selectedCat3Item = cat3;
    await this.loadCategories("cat3");
    this.getExBundles();
  }

  async loadCategories(changeEvent: string): Promise<void> {
     if (this.paramDir == null || this.paramDir.dictionary == null)
      return;

    this.paramDir.dictionary["ChangeEvent"] = changeEvent;
    this.paramDir.dictionary["UserView"] = "true";
    this.paramDir.dictionary["UserId"] = "";
    this.paramDir.dictionary["OrgId"] = "0";
    this.paramDir.dictionary["GroupId"] = "0";
    this.paramDir.dictionary["Category1Id"] = this.selectedCat1Item?.id.toString() ?? "0";
    this.paramDir.dictionary["Category2Id"] = this.selectedCat2Item?.id.toString() ?? "0";
    this.paramDir.dictionary["Category3Id"] = this.selectedCat3Item?.id.toString() ?? "0";

    await rest.url("exercises/loadUserCategories").post(this.paramDir)
    .then((result: CategorySelectListsVm) => {
      this.category1Items = result.category1Items!;
      this.selectedCat1Item = result.selectedCat1Item
      this.category2Items = result.category2Items!;
      this.selectedCat2Item = result.selectedCat2Item
      this.category3Items = result.category3Items!;
      this.selectedCat3Item = result.selectedCat3Item
    })
  }

  get selectedCat1ItemName() {
    if (!this.selectedCat1Item)
      return "-";
    return this.selectedCat1Item.name;
  }

  get selectedCat2ItemName() {
    if (!this.selectedCat2Item)
      return "-";
    return this.selectedCat2Item.name;
  }

  get selectedCat3ItemName() {
    if (!this.selectedCat3Item)
      return "-";
    return this.selectedCat3Item.name;
  }

  getBundleName(exBundle: ExBundleVM): string {
    if (!exBundle) return "Unbekannte Schulung";
    return exBundle.certificateTitle ? exBundle.certificateTitle : exBundle.name ?? "Unbekannte Schulung";
  }

  get cardStyle() {
    // Use a slightly darker translucent background in dark mode,
    // but a very light tint in light mode for better contrast.
    const dark = this.$vuetify && this.$vuetify.theme && this.$vuetify.theme.dark;
    return {
      backgroundColor: dark ? '#60606040' : 'rgba(60,60,60,0.06)'
    };
  }

  async getResults() {
    this.resultsOverview = await rest.url("exercises/getResultsOverview").get();
    // console.log(this.resultsOverview);
  }

  async getExBundles() {
    this.bundleAssignments = []; // Workaround to make sure that placeholder image shows up if bundle logo is not available;
    let param: ParamGetExercises = {
      orgId: 0, // not relevant
      groupId: 0, // not relevant
      subGroupId: 0, // not relevant
      userId: null, // not relevant
      category1Id: this.selectedCat1Item?.id ?? 0,
      category2Id: this.selectedCat2Item?.id ?? 0,
      category3Id:  this.selectedCat3Item?.id ?? 0,
      bundleId: 0, // not relevant
      enabled: true,
      writeResults: true,
      showUserView: true,
      showUnreleasedAssignments: false
    };
    this.bundleAssignments = await rest.url("exercises/getAssignedExBundles").post(param);
    // initialize filtered list
    this.filteredBundleAssignments = this.bundleAssignments ? [...this.bundleAssignments] : [];
    this.applyFilter();
  }

  async showExerciseBundle(assignment: ExBundleAssignmentVM) {
    // Check if we're already on the exerciseBundle route to prevent redundant navigation
    if (this.$route.name === 'exerciseBundle' || this.$route.path === '/exerciseBundle') {
      return;
    }

    await this.$store.commit('globals/setExBundleAssignment', assignment);
    // await vuex.globals.setSelectedLanguageCode(assignment?.exBundle?.masterLanguageCode ?? "de_DE");

    // Use router.push with error handling
    router.push("/exerciseBundle").catch(err => {
      // Ignore navigation duplicated error
      if (err.name !== 'NavigationDuplicated') {
        console.error('Navigation error:', err);
      }
    });
  }

  openCourseDescription(item: ExBundleAssignmentVM) {
    const raw = item.exBundle?.certificateSummary ?? '';
    this.certDialogText = raw.replace(/\r?\n/g, '<br/>');
    this.certDialogTitle = item.exBundle?.certificateTitle ? item.exBundle.certificateTitle : item.exBundle?.name ?? 'Beschreibung';
    this.showCertDialog = true;
  }

  applyFilter() {
    const q = (this.searchQuery || '').trim().toLowerCase();
    if (!this.bundleAssignments) {
      this.filteredBundleAssignments = [];
      return;
    }
    if (!q) {
      this.filteredBundleAssignments = [...this.bundleAssignments];
      return;
    }

    this.filteredBundleAssignments = this.bundleAssignments.filter(a => {
      const name = (a.exBundle?.name || '').toLowerCase();
      const cert = (a.exBundle?.certificateSummary || '').toLowerCase();
      return name.includes(q) || cert.includes(q);
    });
  }

  // toLocalDateString(date: Date | null): string {
  //   if (!date) return "";

  //   return this.$globalHelper.toLocalDateString(date);
  // }

  // dateToLocal(date: string) {
  //   if (!date) return "";

  //   let dateFormated = moment(date).toDate().toLocaleString([], {year: 'numeric', month:  '2-digit', day: '2-digit'});
  //   return dateFormated;
  // }

  goBack() {
    router.go(-1);
  }

  // Accessibility helper methods
  getExerciseBundleAriaLabel(item: ExBundleAssignmentVM): string {
    const name = item.exBundle?.name || 'Unbekannte Schulung';
    const status = this.getStatusText(item);
    const category = this.getCategoryText(item);

    return `Schulung: ${name}, Status: ${status}, Kategorie: ${category}`;
  }

  getHeaderAriaLabel(item: ExBundleAssignmentVM): string {
    if (item.processingTimeExceeded) {
      return `Warnung: ${item.header}`;
    }
    if (item.isCritical) {
      return `Kritisch: ${item.header}`;
    }
    return item.header || '';
  }

  getCategoryAriaLabel(item: ExBundleAssignmentVM): string {
    const cat1 = item.exBundle?.category1 || '';
    const cat2 = item.exBundle?.category2 || '';
    const cat3 = item.exBundle?.category3 || '';
    return `Kategorie: ${cat1}, ${cat2}, ${cat3}`;
  }

  getApprovalAriaLabel(item: ExBundleAssignmentVM): string {
    const date = item.finishedByAdminDate ? this.$globalHelper.toLocalDateString(item.finishedByAdminDate) : 'Unbekannt';
    return `Freigabe erteilt von ${item.finishedByAdminName} am ${date}`;
  }

  getStatusAriaLabel(item: ExBundleAssignmentVM): string {
    return `Status: ${this.getStatusText(item)}`;
  }

  private getStatusText(item: ExBundleAssignmentVM): string {
    if (item.finishedByAdmin) {
      return 'Freigegeben';
    }
    if (item.processingTimeExceeded) {
      return 'Bearbeitungszeit überschritten';
    }
    if (item.isCritical) {
      return 'Kritisch';
    }
    return 'Verfügbar';
  }

  private getCategoryText(item: ExBundleAssignmentVM): string {
    const categories = [
      item.exBundle?.category1,
      item.exBundle?.category2,
      item.exBundle?.category3
    ].filter(Boolean);
    return categories.join(', ');
  }

  get infoBtnStyle() {
    const dark = this.$vuetify && this.$vuetify.theme && this.$vuetify.theme.dark;
    return {
      position: 'absolute',
      bottom: '8px',
      right: '8px',
      zIndex: '2',
      // Dark mode: darker background for white text contrast
      // Light mode: lighter background for dark text contrast
      backgroundColor: dark ? 'rgba(33, 33, 33, 0.7)' : 'rgba(245, 245, 245, 0.75)',
      // Ensure the border also has some contrast
      borderColor: dark ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)'
    };
  }

  get focusStyle() {
    return {
      '--focus-border-color': this.$store.state.ux.colorAccent,
      '--focus-bg-color': this.$store.state.ux.colorAccent + '20' // Add transparency
    };
  }
}
